import Carousel from '../components/Carousel';
import Slider from '../components/Slider';
import { $ } from '../util/DOM';

const getLinkHtml = (el) => {
  const qs = el.getAttribute('data-link-content');
  if (!qs) {
    return '';
  }
  const content = el.querySelector(qs);
  if (!content) {
    return '';
  }
  return content.innerHTML;
};

const sliderControlComponents = {
  arrows: (slider) => $.render('div', {
    className: 'slider-controls__arrows',
    children: [
      $.render('button', {
        type: 'button',
        className: 'prev',
        attrs: { 'aria-label': 'Voltar slide' },
        innerHTML: /* html */ `
        <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.15489e-08 5.99997C6.89843e-08 5.7849 0.0840331 5.56987 0.251746 5.4059L5.53196 0.24617C5.86785 -0.0820565 6.41243 -0.0820565 6.74819 0.24617C7.08394 0.574263 7.08394 1.10632 6.74819 1.43457L2.07596 5.99997L6.74802 10.5654C7.08377 10.8936 7.08377 11.4256 6.74802 11.7537C6.41227 12.0821 5.86769 12.0821 5.5318 11.7537L0.251582 6.59404C0.0838424 6.42999 7.41125e-08 6.21495 7.15489e-08 5.99997Z" fill="#EA6925"/>
        </svg>
        `,
        events: {
          click: () => {
            slider.goPrev();
          },
        },
      }),
      $.render('button', {
        type: 'button',
        className: 'next',
        attrs: { 'aria-label': 'Avançar slide' },
        innerHTML: /* html */ `
        <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7 6.00003C7 6.2151 6.91597 6.43013 6.74825 6.5941L1.46804 11.7538C1.13215 12.0821 0.587565 12.0821 0.251814 11.7538C-0.0839379 11.4257 -0.0839379 10.8937 0.251814 10.5654L4.92404 6.00003L0.251976 1.43461C-0.0837752 1.10639 -0.0837752 0.574383 0.251976 0.246316C0.587728 -0.0820694 1.13231 -0.0820694 1.4682 0.246316L6.74842 5.40596C6.91616 5.57001 7 5.78505 7 6.00003Z" fill="#EA6925"/>
        </svg>
        `,
        events: {
          click: () => {
            slider.goNext();
          },
        },
      }),
    ],
  }),
  counters: (slider) => {
    const children = slider.children.map((el, i) => $.render('button', {
      type: 'button',
      textContent: i + 1,
      attrs: { 'aria-label': `Ver o slide ${i + 1}` },
      events: { click: () => slider.goTo(i) },
    }));

    slider.on('render', () => {
      children.forEach((btn, btnIndex) => {
        if (btnIndex === slider.index) {
          btn.classList.add('is-active');
        } else {
          btn.classList.remove('is-active');
        }
      });
    });

    return $.render('div', {
      className: 'slider-controls__counters',
      children,
    });
  },
  links: (slider) => {
    const children = slider.children.map((el, i) => $.render('div', {
      innerHTML: getLinkHtml(el),
      tabindex: '-1',
      events: { click: () => slider.goTo(i) },
    }));

    slider.on('render', () => {
      children.forEach((btn, btnIndex) => {
        if (btnIndex === slider.index) {
          btn.classList.add('is-active');
        } else {
          btn.classList.remove('is-active');
        }
      });
    });

    return $.render('div', {
      className: 'slider-controls__links',
      children,
    });
  },
};

const generateControls = (slider, keys) => keys.map((key) => {
  if (!(key in sliderControlComponents)) {
    // eslint-disable-next-line no-console
    console.warn(`Opção de controle inválida: ${key}. As opções disponíveis são ${
      Object.keys(sliderControlComponents).join(', ')
    }`);
    return null;
  }
  return sliderControlComponents[key](slider);
});

const setSliderControls = (slider, controlOptions) => {
  if (!controlOptions) {
    return;
  }
  const controlKeys = controlOptions.trim().split(' ');
  if (!controlKeys.length) {
    return;
  }

  const container = $.render('div', {
    className: 'slider-controls__container',
    children: generateControls(slider, controlKeys),
  });

  slider.container.insertAdjacentElement('afterEnd', container);
};

const createSlider = (container, type) => {
  const play = container.hasAttribute('data-play');
  const interval = container.getAttribute('data-interval') || 3000;
  const height = container.getAttribute('data-height');
  const controls = container.getAttribute('data-controls');

  const slider = (
    type === 'carousel'
      ? new Carousel(container, { interval })
      : new Slider(container, { interval })
  );

  if (play) {
    slider
      .on('mouseover', () => slider.pause())
      .on('mouseout', () => slider.play())
      .play();
  }

  if (height) {
    slider.container.style.height = height;
  }

  if (controls) {
    setSliderControls(slider, controls);
  }

  return slider;
};

const createCarousel = (container) => {
  createSlider(container, 'carousel');
};

const initSliders = () => {
  $('.slider').forEach(createSlider);
  $('.carousel').forEach(createCarousel);
};

export default initSliders;
